import { render, staticRenderFns } from "./BranchInfoTable.vue?vue&type=template&id=edcefad8&"
import script from "./BranchInfoTable.vue?vue&type=script&lang=js&"
export * from "./BranchInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports